// src/modules/financials/components/CapitalExposureSection.jsx
import React from 'react';
import { Card, Row, Col, Statistic, Progress, Typography } from 'antd';
import { FundOutlined, WarningOutlined } from '@ant-design/icons';

const { Text } = Typography;

const inr = (v) => `₹${Number(v || 0).toLocaleString('en-IN')}`;

const CapitalExposureSection = ({ data = {}, loading = false }) => {
  const {
    activeCases = 0,
    totalExposure = 0,
    totalAdvancePaid = 0,
    totalRemainingLoan = 0,
    totalEstimatedValue = 0,
  } = data;

  const recoveryPercent = totalExposure > 0
    ? Math.min(100, Math.round((totalAdvancePaid / totalExposure) * 100))
    : 0;

  const loanCoveragePercent = totalRemainingLoan > 0 && totalEstimatedValue > 0
    ? Math.min(200, Math.round((totalEstimatedValue / totalRemainingLoan) * 100))
    : 0;

  return (
    <Card
      title={<span><FundOutlined style={{ color: '#fa8c16', marginRight: 8 }} />Capital Exposure</span>}
      style={{ borderRadius: 12, border: '1px solid #f0f0f0', boxShadow: '0 2px 8px rgba(0,0,0,0.06)' }}
      loading={loading}
    >
      <Row gutter={[16, 16]}>
        <Col xs={12} md={6}>
          <Statistic
            title="Active Pledge Cases"
            value={activeCases}
            valueStyle={{ color: '#1890ff', fontSize: 22, fontWeight: 600 }}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title="Total Exposure"
            value={inr(totalExposure)}
            valueStyle={{ color: '#cf1322', fontSize: 18 }}
            prefix={<WarningOutlined />}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title="Advance Paid"
            value={inr(totalAdvancePaid)}
            valueStyle={{ color: '#3f8600', fontSize: 18 }}
          />
        </Col>
        <Col xs={12} md={6}>
          <Statistic
            title="Remaining Loan"
            value={inr(totalRemainingLoan)}
            valueStyle={{ color: '#fa8c16', fontSize: 18 }}
          />
        </Col>
      </Row>

      <Row gutter={[24, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} md={12}>
          <Text type="secondary" style={{ fontSize: 13 }}>Advance Recovery</Text>
          <Progress
            percent={recoveryPercent}
            strokeColor={recoveryPercent > 70 ? '#52c41a' : recoveryPercent > 40 ? '#faad14' : '#ff4d4f'}
            style={{ marginTop: 4 }}
          />
        </Col>
        <Col xs={24} md={12}>
          <Text type="secondary" style={{ fontSize: 13 }}>Gold Value vs Loan Coverage</Text>
          <Progress
            percent={Math.min(loanCoveragePercent, 100)}
            strokeColor={loanCoveragePercent > 100 ? '#52c41a' : loanCoveragePercent > 70 ? '#faad14' : '#ff4d4f'}
            format={() => `${loanCoveragePercent}%`}
            style={{ marginTop: 4 }}
          />
        </Col>
      </Row>

      <Row style={{ marginTop: 16 }}>
        <Col span={24}>
          <Statistic
            title="Estimated Gold Value (Active Cases)"
            value={inr(totalEstimatedValue)}
            valueStyle={{ color: '#d4a017', fontSize: 18 }}
          />
        </Col>
      </Row>
    </Card>
  );
};

export default CapitalExposureSection;
